module.exports = __webpack_public_path__ + "static/media/kg.d3ce0439.webp";